import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-light-bottom-svg',
  templateUrl: './light-bottom-svg.component.html',
  styleUrls: ['./light-bottom-svg.component.scss']
})
export class LightBottomSvgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
